/**
 * Case-insensitive substring match across the three title fields a pair can
 * carry, shared by the EntryPage search box and the BucketPage search so the
 * two filters keep an identical contract. Empty / whitespace-only query
 * matches everything.
 */
export interface PairTitleFields {
  pairName?: string;
  kalshiTitle?: string;
  polymarketTitle?: string;
}

export function matchesPairTitleSearch(
  pair: PairTitleFields,
  query: string
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [pair.pairName, pair.kalshiTitle, pair.polymarketTitle].some(title =>
    (title ?? '').toLowerCase().includes(q)
  );
}
